// import React, { Component } from "react";
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Table,
//   Row,
//   Col,
//   NavLink,
//   Nav,
//   NavItem,
// } from "reactstrap";
// import API from "api.js";
// import Unauthorized from "components/Exceptions/Unauthorized";
// import SidebarClose from "components/Sidebar/SidebarClose";

// import { thead, tbody } from "variables/general";

// class MockResult extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [],
//       arr: {
//         1: [1, 2, 3, 4, 5],
//         2: [6, 7],
//         3: [8, 9, 10, 11, 12],
//         4: [13, 14, 15, 16, 17, 18, 19, 20],
//       },
//       group: [],
//       activeTab: 1,
//       f: true,
//       unauthorized: false,
//       isLoaded: false,
//     };
//   }
//   componentDidMount() {
//     API({
//       method: "GET",
//       url: "mock/resultDetail/" + this.props.match.params.id,
//     })
//       .then((data) => {
//         this.setState({ isLoaded: true });
//         if (
//           typeof data.data.message !== "undefined" &&
//           typeof data.data.message !== undefined &&
//           data.data.message === "unauthorized access"
//         ) {
//           this.setState({ unauthorized: true });
//         }
//         let group = data.data.data.question.reduce((r, a) => {
//           r[a.type] = [...(r[a.type] || []), a];
//           return r;
//         }, {});
//         this.setState({ group: group, data: data.data.data.question });
//       })
//       .catch(() => {});
//   }

//   getQuestionType = (type) => {
//     let title = "";
//     switch (type) {
//       case 1:
//         title = "Read Aloud";
//         break;
//       case 2:
//         title = "Repeat Sentence";
//         break;
//       case 3:
//         title = "Describe Image";
//         break;
//       case 4:
//         title = "Re-tell Lecture";
//         break;
//       case 5:
//         title = "Answer Short Questions";
//         break;
//       case 6:
//         title = "Summarize written text";

//         break;
//       case 7:
//         title = "Write Essay";

//         break;
//       case 8:
//         title = "Multiple Type, Single Answer ";
//         break;
//       case 9:
//         title = "Multiple Type, Double Answer ";
//         break;
//       case 10:
//         title = "Reorder Paragraph ";
//         break;
//       case 11:
//         title = "Reading Fill in the Blanks ";
//         break;
//       case 12:
//         title = "Fill in the Blanks Reading & Writing ";
//         break;
//       case 13:
//         title = "Summarize Spoken text ";
//         break;
//       case 14:
//         title = "MCQ Single answer ";
//         break;
//       case 15:
//         title = "MCQ multiple answer ";
//         break;
//       case 16:
//         title = "Listening Fill In the Blanks ";
//         break;
//       case 17:
//         title = "Highlight correct summary ";
//         break;
//       case 18:
//         title = "Select Missing Word ";
//         break;
//       case 19:
//         title = "Highlight Incorrect word ";
//         break;
//       case 20:
//         title = "Write from Dictation ";

//         break;
//       default:
//       // code block
//     }
//     return title;
//   };

//   calculateScore = (arr) => {
//     let score = 0;
//     let from = 0;
//     arr.map((v) => {
//       v.score.map((val) => {
//         score += val.score;
//         from += val.from;
//       });
//     });
//     let per = score*100/from;
//     return per.toFixed(2) + " %"; // new way of display score.
//     // return `${score > 0 ? score.toFixed(1) : score} out of ${from}`; // Old way of display
//   };

//   getTime = (arr) => {
//     let time = 0;
//     arr.map((v) => {
//       time += v.q_time;
//     });
//     return time > 59
//       ? `${Math.floor(time / 60)} minutes ${Math.floor(time % 60)} sec`
//       : `${time} sec`;
//   };

//   getUnattempted = (arr) => {
//     let c = 0;
//     arr.map((v) => {
//       if (v.not_attempted === 0) {
//         c += 1;
//       }
//     });
//     return c;
//   };

//   toggleCorrectSection = () => {
//     let tab = 1;
//     if (
//       Object.keys(this.state.group).filter((x) =>
//         [1, 2, 3, 4, 5].includes(parseInt(x))
//       ).length > 0
//     ) {
//       tab = 1;
//     } else if (
//       Object.keys(this.state.group).filter((x) => [6, 7].includes(parseInt(x)))
//         .length
//     ) {
//       tab = 2;
//     } else if (
//       Object.keys(this.state.group).filter((x) =>
//         [8, 9, 10, 11, 12].includes(parseInt(x))
//       ).length
//     ) {
//       tab = 3;
//     } else {
//       tab = 4;
//     }
//     this.setState({ activeTab: tab, f: false });
//   };

//   toggle = (tab) => {
//     if (this.state.activeTab !== tab) {
//       this.setState({ activeTab: tab });
//     }
//   };

//   render() {
//     if (this.state.data.length > 0 && this.state.f) {
//       this.toggleCorrectSection();
//     }

//     return (
//       <>
//         {!this.state.isLoaded ? (
//           <></>
//         ) : (
//           <>
//             {!this.state.unauthorized ? (
//               <>
//                 <div className="content">
//                   {/* <SidebarClose /> */}
//                   <Row>
//                     <Col xs={12}>
//                       <Card>
//                         <CardHeader>
//                           <CardTitle tag="h4">Mock Test Analysis</CardTitle>
//                         </CardHeader>
//                         <CardBody>
//                           <div>
//                             <Nav
//                               className="nav-pills-primary nav-pills-icons justify-content-center"
//                               pills
//                               role="tablist"
//                               tabs
//                             >
//                               {Object.keys(this.state.group).filter((x) =>
//                                 [1, 2, 3, 4, 5].includes(parseInt(x))
//                               ).length !== 0 && (
//                                 <NavItem>
//                                   <NavLink
//                                     className={
//                                       this.state.activeTab === 1 ? "active" : ""
//                                     }
//                                     onClick={() => {
//                                       this.toggle(1);
//                                     }}
//                                   >
//                                     Speaking
//                                   </NavLink>
//                                 </NavItem>
//                               )}
//                               {Object.keys(this.state.group).filter((x) =>
//                                 [6, 7].includes(parseInt(x))
//                               ).length !== 0 && (
//                                 <NavItem>
//                                   <NavLink
//                                     className={
//                                       this.state.activeTab === 2 ? "active" : ""
//                                     }
//                                     onClick={() => {
//                                       this.toggle(2);
//                                     }}
//                                   >
//                                     Writing
//                                   </NavLink>
//                                 </NavItem>
//                               )}
//                               {Object.keys(this.state.group).filter((x) =>
//                                 [8, 9, 10, 11, 12].includes(parseInt(x))
//                               ).length !== 0 && (
//                                 <NavItem>
//                                   <NavLink
//                                     className={
//                                       this.state.activeTab === 3 ? "active" : ""
//                                     }
//                                     onClick={() => {
//                                       this.toggle(3);
//                                     }}
//                                   >
//                                     Reading
//                                   </NavLink>
//                                 </NavItem>
//                               )}
//                               {Object.keys(this.state.group).filter((x) =>
//                                 [13, 14, 15, 16, 17, 18, 19, 20].includes(
//                                   parseInt(x)
//                                 )
//                               ).length !== 0 && (
//                                 <NavItem>
//                                   <NavLink
//                                     className={
//                                       this.state.activeTab === 4
//                                         ? "active no-border"
//                                         : "no-border"
//                                     }
//                                     onClick={() => {
//                                       this.toggle(4);
//                                     }}
//                                   >
//                                     Listening
//                                   </NavLink>
//                                 </NavItem>
//                               )}
//                             </Nav>
//                           </div>
//                           <Table>
//                             <thead className="text-primary">
//                               <tr>
//                                 <th className="">Question Type</th>
//                                 <th className="">Time</th>
//                                 <th className="">Question Count</th>
//                                 <th className="">Question Attempted</th>
//                                 <th className="">Score %</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {Object.keys(this.state.group).map((val, key) => {
//                                 if (
//                                   this.state.arr[this.state.activeTab].includes(
//                                     parseInt(val)
//                                   )
//                                 ) {
//                                   return (
//                                     <tr key={key}>
//                                       <td className="">
//                                         {this.getQuestionType(parseInt(val))}
//                                       </td>
//                                       <td className="">
//                                         {this.getTime(this.state.group[val])}
//                                       </td>
//                                       <td className="">
//                                         {this.state.group[val].length}
//                                       </td>
//                                       <td className="">
//                                         {this.getUnattempted(
//                                           this.state.group[val]
//                                         )}
//                                       </td>
//                                       <td className="">
//                                         {this.calculateScore(
//                                           this.state.group[val]
//                                         )}
//                                       </td>
//                                     </tr>
//                                   );
//                                 }
//                               })}
//                             </tbody>
//                           </Table>
//                         </CardBody>
//                       </Card>
//                     </Col>
//                   </Row>
//                 </div>
//               </>
//             ) : (
//               <Unauthorized />
//             )}
//           </>
//         )}
//       </>
//     );
//   }
// }

// export default MockResult;


import React, { useState, useEffect, useCallback } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  NavLink,
  Nav,
  NavItem,
} from "reactstrap";
import API from "api.js";
import Unauthorized from "components/Exceptions/Unauthorized";
import SidebarClose from "components/Sidebar/SidebarClose";
import LaLoader from "components/Loader/LaLoader";
import { useParams } from "react-router-dom";
import "../assets/css/new-custom-style.css";
import "./Score.css";
import { useSelector } from "react-redux";

const MockResult = ({ match }) => {
   const user = useSelector((state) => state.user);
  const [state, setState] = useState({
    data: [],
    arr: {
      1: [1, 2, 3, 4, 5, 21, 22],
      2: [6, 7],
      3: [8, 9, 10, 11, 12],
      4: [13, 14, 15, 16, 17, 18, 19, 20],
    },
    group: [],
    activeTab: 1,
    f: true,
    unauthorized: false,
    isLoaded: false,
  });

  const { type, id } = useParams()

  useEffect(() => {
    API({
      method: "GET",
      url: "mock/resultDetail/" + id,
    })
      .then((data) => {
        setState((prevState) => ({ ...prevState, isLoaded: true }));
        if (
          data.data.message === "unauthorized access"
        ) {
          setState((prevState) => ({ ...prevState, unauthorized: true }));
        }
        let group = data.data.data.question.reduce((r, a) => {
          r[a.type] = [...(r[a.type] || []), a];
          return r;
        }, {});
        setState((prevState) => ({ ...prevState, group: group, data: data.data.data.question }));
      })
      .catch(() => {});
  }, [id]);

  const questionTypeMap = {
    1: { title: "Read Aloud"},
    2: { title: "Repeat Sentence" },
    3: { title: "Describe Image"},
    4: { title: "Re-tell Lecture"},
    5: { title: "Answer Short Questions"},
    6: { title: "Summarize Written Text" },
    7: { title: "Write Essay" },
    8: { title: "Multiple Choice, Single Answers" },
    9: { title: "Multiple Choice, Multiple Answers" },
    10: { title: "Reorder Paragraph" },
    11: { title: "Fill In The Blanks (Drop-Down)" },
    12: { title: "Fill In The Blanks (Drag & Drop)" },
    13: { title: "Summarize Spoken Text"},
    14: { title: "Multiple Choice, Single Answers" },
    15: { title: "Multiple Choice, Multiple Answers" },
    16: { title: "Fill In the Blanks (Type In)"},
    17: { title: "Highlight Correct Summary" },
    18: { title: "Select Missing Words" },
    19: { title: "Highlight Incorrect Words" },
    20: { title: "Write from Dictation"},
    21: { title: "Respond To Situation"},
    22: { title: "Summarize Group Discussion" },
  };

  const getQuestionInfo = (type) => {
    return questionTypeMap[type] || { title: "Unknown", id: "uk" };
  };

  const getScoreData = (arr) => {
    let score = 0;
    let from = 0;
    arr.map((v) => {
      v.score.map((val) => {
        score += val.score;
        from += val.from;
      });
    });
    let per = from > 0 ? (score * 100) / from : 0;
    return {
        percent: per.toFixed(1),
        status: per < 50 ? 'acc-low' : per < 75 ? 'acc-med' : 'acc-high'
    };
  };

  const getTimeFormatted = (arr) => {
    let time = 0;
    arr.map((v) => {
      time += v.q_time;
    });
    const avg = time / arr.length;
    const mins = Math.floor(avg / 60);
    const secs = Math.floor(avg % 60);
    return `${mins}m ${secs}s`;
  };

  const getUnattemptedCount = (arr) => {
    let c = 0;
    arr.map((v) => {
      if (v.not_attempted === 0) {
        c += 1;
      }
    });
    return c;
  };

  const toggleCorrectSection = () => {
    let tab = 1;
    const groupKeys = Object.keys(state.group).map(Number);
    if (groupKeys.some(x => state.arr[1].includes(x))) {
      tab = 1;
    } else if (groupKeys.some(x => state.arr[2].includes(x))) {
      tab = 2;
    } else if (groupKeys.some(x => state.arr[3].includes(x))) {
      tab = 3;
    } else if (groupKeys.some(x => state.arr[4].includes(x))) {
      tab = 4;
    }
    setState((prevState) => ({ ...prevState, activeTab: tab, f: false }));
  };

  const getTargetedPercentage = useCallback((value) => {
    console.log("The value we got is : ", value);
    console.log("This is user Data SCORE : ", user.score);
  
    if (user.score == null) {
      return 0;
    }
    
    if ([1, 2, 3, 4, 5, 21, 22].includes(value)) {
      return user.score >= 65 ? 85 : (user.score <= 50 ? 70 : 50);
    }
  
    if ([6, 7].includes(value)) {
      if (value === 6) {
        return user.score >= 65 ? 90 : (user.score <= 50 ? 80 : 50);
      }
      if (value === 7) {
        return user.score >= 65 ? 85 : (user.score <= 50 ? 70 : 50);
      }
    }
    
    if ([10, 11, 12].includes(value)) {
      return user.score >= 65 ? 70 : (user.score <= 50 ? 50 : 50);
    }
  
    if ([13, 16, 19, 20].includes(value)) {
      if (value === 13) {
        return user.score >= 65 ? 90 : (user.score <= 50 ? 70 : 50);
      }
      if (value === 16) {
        return user.score >= 65 ? 90 : (user.score <= 50 ? 60 : 50);
      }
      if (value === 19) {
        return user.score >= 65 ? 95 : (user.score <= 50 ? 70 : 50);
      }
      if (value === 20) {
        return user.score >= 65 ? 95 : (user.score <= 50 ? 70 : 50);
      }
    }
    
    return 50;
  }, [user.score]);

  const toggle = (tab) => {
    if (state.activeTab !== tab) {
      setState((prevState) => ({ ...prevState, activeTab: tab }));
    }
  };

  useEffect(() => {
    if (state.data.length > 0 && state.f) {
      toggleCorrectSection();
    }
  }, [state.data, state.f]);

  const activeQuestionTypes = Object.keys(state.group).filter(val => 
    state.arr[state.activeTab].includes(parseInt(val))
  );

  return (
    <>
      {!state.isLoaded ? (
        <LaLoader show={!state.isLoaded} />
      ) : (
        <>
          {!state.unauthorized ? (
            <div className="content tabs-content p-0">
              <Row>
                <Col xs={12}>
                  <Card className="mock-analysis-container shadow-sm">
                    <CardHeader className="bg-white px-0 mx-4 mt-2 border-0">
                      <div className="detailed-breakdown-header d-flex align-items-center justify-content-between">
                        <h4 className="db-title mt-0 mb-0">Detailed Breakdown</h4>
                        <span className="db-count">{activeQuestionTypes.length} Question Types</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-start flex-wrap flex-md-nowrap mt-3">
                        <style>
                          {`
                            .mock-analysis-container .nav-tabs .nav-link.active {
                              background-color: #19181c !important;
                              color: #ffffff !important;
                            }
                            .mock-analysis-container .nav-tabs .nav-link:hover {
                              background-color: #19181c !important;
                              color: #ffffff !important;
                            }
                         
                          `}
                        </style>
                        <Nav
                          className="nav-tabs nav-pills-primary nav-pills-icons justify-content-start"
                          tabs
                          role="tablist"
                        >
                          {[
                            { id: 1, label: "Speaking" },
                            { id: 2, label: "Writing" },
                            { id: 3, label: "Reading" },
                            { id: 4, label: "Listening" },
                          ].map((item) => {
                            const hasQuestions = Object.keys(state.group).filter((x) =>
                              state.arr[item.id].includes(parseInt(x))
                            ).length !== 0;

                            if (!hasQuestions) return null;

                            return (
                              <NavItem key={item.id} className="me-2">
                                <NavLink
                                  className={`${state.activeTab === item.id ? "active" : ""}`}
                                  onClick={() => toggle(item.id)}
                                >
                                  {item.label}
                                </NavLink>
                              </NavItem>
                            );
                          })}
                        </Nav>
                      </div>
                    </CardHeader>
                    <CardBody className="px-4">
                      
                      <div className="table-responsive">
                        <Table className="mock-analysis-table border-top-0">
                          <thead>
                            <tr>
                              <th style={{ width: '27%' }}>Question Type</th>
                              <th style={{ width: '15%' }}>Time Spent</th>
                              <th style={{ width: '15%' }}>Attempted</th>
                              <th style={{ width: '27%' }}>Accuracy & Score</th>
                               <th style={{ width: '15%' }}>Targeted Accuracy</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeQuestionTypes.map((val, key) => {
                              const info = getQuestionInfo(parseInt(val));
                              const scoreData = getScoreData(state.group[val]);
                              const timeSpent = getTimeFormatted(state.group[val]);
                              const attempted = getUnattemptedCount(state.group[val]);
                              const total = state.group[val].length;

                              return (
                                <tr key={key}>
                                  <td>
                                    <span className="q-type-name">{info.title}</span>
                                  </td>
                                  <td>
                                    <div className="time-spent-cell">
                                      <i className="fa fa-clock-o" aria-hidden="true"></i>
                                      <span>{timeSpent}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <span className="attempted-pill">
                                      {attempted} / {total}
                                    </span>
                                  </td>
                                  <td>
                                    <div className={`accuracy-cell-content ${scoreData.status}`}>
                                      <div className="accuracy-bar-container">
                                        <div 
                                          className="accuracy-fill" 
                                          style={{ width: `${scoreData.percent}%` }}
                                        ></div>
                                      </div>
                                      <span className="accuracy-percent">
                                        {scoreData.percent}%
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    {(() => {
                                    const targetPercentage = getTargetedPercentage(parseInt(val));
                                    const showTooltip = targetPercentage === 50 || (user.score > 50 && user.score < 65);
    
                                    return showTooltip ? (
                                      <span className="d-inline-flex align-items-center gap-1 position-relative">
                                      <span style={{fontWeight:"bold"}}>
                                        {targetPercentage}%
                                        </span>
                                        <span className="info-icon-wrapper">
                                        <i className="bi bi-info-circle-fill info-icon"></i>
                                        <span style={{maxWidth: "88px" ,whiteSpace: "normal",wordWrap: "break-word"}} className="custom-tooltip">
                                         Since this type of question is less important, 50% accuracy will be sufficient.
                                        </span>
                                       </span>
                                      </span>
                                          ) : (
                                            <span style={{fontWeight:"bold"}}>{targetPercentage}%</span>
                                          );
                                      })()}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          ) : (
            <Unauthorized />
          )}
        </>
      )}
    </>
  );
};

export default MockResult;